export default theme => ({
  dialog_addButton_icon: {
    marginRight: theme.spacing(1),
    fontSize: 20,
  },
  dialog_container: {
    textAlign: "center",
  },
});
